<div class="d-flex justify-content-center"><h1 style="font-size: 4rem;">Our Happy Clients</h1></div>
<div class="d-flex justify-content-center">
  <div class="motif__1">
    <img style="height: 6rem; opacity: 0.5;" src="../../assets/images/processpage/10091105.png" alt="" />
  </div>
</div>


<section class="u-clearfix u-section-2" id="sec-cfd9" *ngFor="let item of data">
  <div class="u-align-left u-clearfix u-sheet u-valign-middle-lg u-sheet-1">
    <div class="u-align-left u-border-1 u-border-grey-75 u-container-style u-expanded-width u-group u-radius-35 u-shape-round u-group-1">
      <div class="u-container-layout u-valign-top-lg u-valign-top-md u-valign-top-xl u-container-layout-1">
        <div class="u-container-style u-group u-group-2">
          <div class="u-container-layout u-valign-top u-container-layout-2">
            <img class="u-image u-image-circle u-image-1" src="{{item.logo1}}" alt="" data-image-width="626" data-image-height="417">
            <h2 class="u-align-center u-text u-text-1" [innerText]="item.title"> </h2>
            <p class="u-text u-text-2"> “ {{item.description}} ”&nbsp;&nbsp;</p>
          </div>
        </div>
        <img class="u-image u-image-default u-opacity u-opacity-45 u-image-2" src="../../assets/images/work/879fa54bacb4e95fb1ca1e8427649dc81.png" alt="" data-image-width="650" data-image-height="252">
      </div>
    </div>
  </div>
</section>